import { DashboardType } from './dashboards.types'

export const DASHBOARD_TYPE_IS_AUDIT_SPECIFIC: Record<DashboardType, boolean> =
  {
    [DashboardType.OVERVIEW]: true,
    [DashboardType.OE_OVERVIEW]: true,
    [DashboardType.OE_DETAIL]: true,
    [DashboardType.OE_OVERVIEW_BY_LABEL]: true,
    [DashboardType.OE_DETAIL_BY_LABEL]: true,
    [DashboardType.OE_OVERVIEW_BY_ACCOUNT]: false,
    [DashboardType.OE_DETAIL_BY_ACCOUNT]: false,
    [DashboardType.RISK_RESPONSE]: true,
    [DashboardType.TRUST_PORTAL_ACCESS_REQUESTS]: false,
    [DashboardType.TRUST_PORTAL_GRANTED_REQUESTS]: false,
    [DashboardType.TRUST_PORTAL_DOCUMENT_DOWNLOADS]: false,
    [DashboardType.TRUST_PORTAL_FAQ_CLICKS]: false,
    [DashboardType.TRUST_PORTAL_SEARCHES]: false,
    [DashboardType.TRUST_PORTAL_TI_CHATS]: false,
    [DashboardType.TRUST_PORTAL_TI_QUESTIONS]: false,
    [DashboardType.TRUST_PORTAL_UPDATE_SUBSCRIPTIONS]: false,
    [DashboardType.TRUST_PORTAL_UPDATE_UNSUBSCRIPTIONS]: false,
  }
